import { RootState } from "../../../store";
import { currentDashboardSelector } from "../dashboard/currentDashboardSelector";

export const currentDashboardProtectedSelector = (state: RootState) => {
  return !!currentDashboardSelector(state)?.protection_details?.is_protected;
};
